import { render } from "./checklist-current.vue?vue&type=template&id=ebc5a1ca"
import script from "./checklist-current.vue?vue&type=script&lang=js"
export * from "./checklist-current.vue?vue&type=script&lang=js"

import "./checklist-current.vue?vue&type=style&index=0&id=ebc5a1ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__